import { reasons } from '@/mocks/homeContent';

export default function ReasonsSection() {
  return (
    <section id="reasons" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            REASONS TO CHOOSE
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都で<span className="text-primary-500">選ばれ続ける</span>
            <br className="md:hidden" />
            6つの理由
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都 不用品回収・京都 遺品整理・京都 ゴミ屋敷清掃を数多くお任せいただく理由は、
            スピード・丁寧さ・法人対応力の三拍子が揃っているから。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((reason) => (
            <div
              key={reason.num}
              className="group relative p-7 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors min-h-[280px]"
            >
              {/* Background image */}
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${reason.image})` }}
              />
              <div className="absolute inset-0 bg-black/35" />
              <div className="absolute inset-x-0 bottom-0 h-3/4 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />

              {/* Content */}
              <div className="relative z-10">
                <div className="flex items-start justify-between mb-5">
                  <div className="w-14 h-14 flex items-center justify-center rounded-md bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
                    <span className="w-8 h-8 flex items-center justify-center text-2xl">
                      <i className={reason.icon} />
                    </span>
                  </div>
                  <span className="font-mincho text-4xl text-white/40 leading-none">
                    {reason.num}
                  </span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
                  {reason.title}
                </h3>
                <p className="text-white/90 text-sm leading-relaxed">
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}